import { Component, OnInit, AfterViewInit, Input, OnDestroy } from '@angular/core';
import * as $ from 'jquery';
import { CurrentUser } from '../shared/user.model';

@Component({
  selector: 'pm-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.sass']
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  public pageTitle = 'Dashboard';
  showMenu = true;
  currentUser: CurrentUser = null;

  constructor() {}

  ngOnInit() {}

  DashboardComponent() {
    // $('#menu-catalogos').click();
    $('a[rel=dashboard]').addClass('selected');
    $('body').removeClass('backgroundLogin');

    const sessionUser = localStorage.getItem('currentUser');
    this.currentUser = sessionUser ? (JSON.parse(sessionUser) as CurrentUser) : null;
    console.log('DashboardComponent: DashboardComponent: currentUser: ', this.currentUser);
  }

  ngAfterViewInit() {}

  /*   ngAfterViewInit() {
    //$.getScript('assets/assets/build/js/custom.min.js');
    $('body').css('background-image', 'none');
    $('.btn_second').click(function() {
      $('.s_level').hide();
      $(this)
        .next('.s_level')
        .show();
    });
  } */

  toggleImage(): void {
    console.log(this.showMenu);
    if (this.showMenu !== false) {
      $('aside').css('width', '60px');
      this.showMenu = false;
    } else {
      $('aside').css('width', '160px');
      this.showMenu = true;
    }
  }

  ngOnDestroy() {
    $('a[rel=dashboard]').removeClass('selected');
  }
}
